import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const PageNotFound = () => {
    const navigate = useNavigate()

    useEffect(() => {
        if(sessionStorage.getItem('IdToken')  === null){
            navigate('/')
        }
    }, [])
    
    return (
        <></>
    )
}

export default PageNotFound